<!--
 * @Author       : chenyuchao c375880854@163.com
 * @Date         : 2024-08-22 09:32:39
 * @LastEditTime : 2024-08-23 17:56:33
 * @LastEditors  : chenyuchao
 * @Description  : 供销一体化
 * @Remark       :
-->

<template>
    <div class="page-box">
      <Header/>
      <div class="mg-bottom-70 bg-color-EAF1FA">
        <TopBanner :top-banner-img="BannerImg" title2="B2B2C供销一体化系统" title-row1="整合优质供应链资源，从消费者场景出发" title-row2="助企业构建完整" blue-text="交易生态网络" :tips-flex="true" :title-tips-list="titleTipsList" :contentStype="{paddingTop: '186px'}" />
      </div>
      <ModuleTitle data-aos="fade-up" bg-color="#fff" title="渠道经营痛点" :moduleTipsList="[{name: '协同环节繁杂，易出错、流程长、成本居高不下，经营过程数据难以形成有效应用'}]" />
      <ModuleCenter >
          <div class="flex-box" data-aos="fade-up">
            <CardItem v-for="(item, index) in painList" :key="index" :item="item" :cardStyle="cardStyle"></CardItem>
          </div>
      </ModuleCenter>
      <!-- 从场景出发，构建完整交易生态网络 -->
      <div class="barrier-background pd-top-70 bg-color-F3F4FB" :style="{backgroundImage: 'url('+ IMBanner1 +')'}">
        <ModuleCenter>
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="从场景出发，构建完整交易生态网络" :moduleTipsList="[{name: '聚合资源、打通业务通路，实现上下游高效协同的全网生态'}]" />
          <div class="flex-box" data-aos="fade-up">
            <div class="flex-item" v-for="(item, index) in sceneLsit" :key="index" :style="{backgroundImage: 'url('+ item.bgImg +')', justifyContent: item.postion === 'top'? 'flex-start' : 'flex-end'}">
              <div class="flex-item-title">{{ item.name }}</div>
              <div class="flex-item-desc">{{ item.desc }}</div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 上游供应链高效聚合 -->
      <div class="pd-top-70 mg-bottom-110">
        <ModuleCenter>
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="上游供应链高效聚合" :moduleTipsList="[{name: '通过开放平台实现上游供应链聚合，不仅有助于提高供应链的效率和灵活性，降低成本'}, {name: '还能增强产品质量和服务水平，最终提升客户满意度并增强市场竞争力'}]" />
          <div class="flex-box justify-center-start" data-aos="fade-up">
            <div class="goods-manage-middle" style="margin-right: 98px;">
              <img class="goods-manage-mid-img" src="@/assets/product/digitalSystem/integration-module-1.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne mg-bottom-50">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">供应链数据集成</span>
                  <div>实现供应链各环节的数据集成，包括采购、库存、物流等通过数据集成，提高供应链的透明度，实现信息共享和协同工作</div>
                </div>
              </div>
              <div class="goods-manage-ilne mg-bottom-50">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">库存优化</span>
                  <div>通过整合上游供应链资源，企业能够更精准地预测需求，实现库存的精细化管理，减少积压</div>
                </div>
              </div>
              <div class="goods-manage-ilne mg-bottom-50">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">灵活的采购策略</span>
                  <div>根据市场需求的变化，制定灵活的采购策略，如按需采购、批量采购、长期合同等，以降低采购成本和风险</div>
                </div>
              </div>
              <div class="goods-manage-ilne ">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">订单管理</span>
                  <div>实现订单的自动接收、处理和跟踪，同时，通过订单管理系统与供应商进行协同，提高订单履行的效率和准确性</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 业务全面联通 -->
      <div class="mg-btm-70 bg-color-0B4FD1">
        <ModuleBgBlue >
          <ModuleCenter >
            <div class="core-advantages pd-top-70">
              <ModuleTitle data-aos="fade-up" title="业务全面联通" title-color="#fff" :desc-stype="titleDescStype" :moduleTipsList="[{name: '帮助上下游节点更好地协同工作、提高决策效率、优化业务流程等，从而实现整个供销一体化系统的高效运作'}]" />
              <div class="flex-box" data-aos="fade-up">
                <CardItem v-for="(item, index) in advantageList" :key="index" :item="item" :card-style="advantageCardStyle"></CardItem>
              </div>
            </div>
          </ModuleCenter>
        </ModuleBgBlue>
      </div>
      <!-- 强大的数据分析能力，解决运营难题 -->
      <div class="pd-top-70">
        <ModuleCenter>
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="强大的数据分析能力，解决运营难题" :moduleTipsList="[{name: '全方面了解商城经营数据，消费者行为数据，用于调整策略参考，更有实时交易数据监控'}, {name: '帮助你快速发现数据之间的联系及背后的价值，多维度分析， 让你轻松把握商业趋势，及时应对变化'}]" />
          <div class="flex-box" data-aos="fade-up" style="margin-bottom: 0px;">
            <div class="goods-manage-left goods-manage-item flex-center">
              <div class="goods-manage-ilne mg-bottom-40">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-230">
                  <span class="item-ilne-title">增强决策的数据支持</span>
                  <div>通过全面采集数据，企业能够基于实际数据而非仅凭经验或直觉做出更准确的商业决策</div>
                </div>
              </div>
              <div class="goods-manage-ilne mg-top-40">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-230">
                  <span class="item-ilne-title">优化营销策略</span>
                  <div>准确分析消费者行为和市场趋势，使企业能够设计更有效的营销活动，提高转化率和ROI（投资回报率）</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img module-img-2" src="@/assets/product/digitalSystem/integration-module-2.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item flex-center">
              <div class="goods-manage-ilne mg-bottom-40">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-230">
                  <span class="item-ilne-title">提高运营效率</span>
                  <div>数据驱动的决策有助于优化库存管理、价格策略、供应链管理等，降低运营成本，提升效率</div>
                </div>
              </div>
              <div class="goods-manage-ilne mg-top-40">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-230">
                  <span class="item-ilne-title">跨渠道协同</span>
                  <div>系统可以实现供应商、平台和消费者之间的数据共享，打通各环节，实现无缝协作</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 全网触达 全触点覆盖 -->
      <div class="barrier-background pd-top-70 bg-color-E4EFFF" :style="{backgroundImage: 'url('+ OneStopBannerImg +')'}">
        <ModuleCenter>
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="全网触达 全触点覆盖" :moduleTipsList="[{name: '覆盖消费者接触的各种触点，PC、APP（安卓、iOS）、微信、全网小程序（微信、支付宝、头条、抖音）'}]" />
          <div class="flex-box justify-center-start" data-aos="fade-up">
            <div class="goods-manage-right goods-manage-item" style="margin-right: 68px;padding: 44px 0 44px 0">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width: 450px;">
                  <span class="item-ilne-title">全网覆盖</span>
                  <div>微商城+小程序+APP商城+PC商城+移动商城，全网覆盖，支持类似于小红书种草+电商购物的模式</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width: 450px;">
                  <span class="item-ilne-title">直播导购</span>
                  <div>借助直播先天优势，通过现场互动、实物演示、在线答疑，增强顾客信任，加速购买 决策。用商联达商城打通直播系统，轻松实现边播边卖，提升购买转化</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width: 450px;">
                  <span class="item-ilne-title">短视频导购</span>
                  <div>短视频比起图文更加生动、有趣，也利于传播，可开始同步至抖音、快手等短视频平台</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img style="width: 650px;height: 450px;" class="goods-manage-mid-img" src="@/assets/product/digitalSystem/integration-module-3.png" alt="" />
            </div>
          </div>
        </ModuleCenter>
      </div>
      <Footer/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TopBanner from './components/topBanner.vue'
import Banner from '@/assets/product/digitalSystem/banner-2.jpg'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import CardItem from './components/cardItem.vue'
import IMBanner1 from '@/assets/product/digitalSystem/integration-module-banner-1.png'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import OneStopBanner from '@/assets/product/digitalSystem/One-Stop-banner.png'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.integration,
  components: {
    Header,
    Footer,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    IMBanner1,
    ModuleBgBlue
  },
   data() {
      return {
        OneStopBannerImg: OneStopBanner,
        CancelImg: Cancel,
        BannerImg: Banner,
        IMBanner1: IMBanner1,
        titleTipsList: [
          {
            name: '优化资源配置'
          },
          {
            name: '降低运营成本'
          },
          {
            name: '提高运营效率'
          },
          {
            name: '拓展销售渠道'
          },
          {
            name: '增强供应链稳定性'
          }
        ],
        painList: [
          {
            icon: require("@/assets/product/svgIcon/pain-spot-4.svg"),
            name: '上游链接难',
            imgShow: false,
            descList: [
              '与上游系统缺少链接，无法共享上游库存，线下询价，效率低容易出错',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-6.svg"),
            name: '获客成本高',
            imgShow: false,
            descList: [
              '线下渠道流量减少，自有官网或小程序不成体系，难以形成稳定客源',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-7.svg"),
            name: '营销手段少',
            imgShow: false,
            descList: [
              '与用户交互触点少，线下效果不明显，难以实现用户全生命周期的闭环',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-5.svg"),
            name: '同质化竞争加剧',
            imgShow: false,
            descList: [
              '受线上平台、社群、直播影响，价格竞争激烈，渠道利润优势不在',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-8.svg"),
            name: '数据难以形成资产',
            imgShow: false,
            descList: [
              '数据分散、不完整、链路数据缺失，难以建成数据体系进行经营赋能',
            ]
          }
        ],
        cardStyle: {
          width: '224px',
          height: '220px',
          padding: '30px 20px 0 20px'
        },
        sceneLsit: [
          {
            bgImg: require('@/assets/product/digitalSystem/scene-1.png'),
            name: '上游供应链聚合',
            desc: '开放平台打通上游供应链资源，快速适应市场，减少库存压力',
            postion: 'bottom'
          },
          {
            bgImg: require('@/assets/product/digitalSystem/scene-2.png'),
            name: '全链路互通提升效率',
            desc: '上下游节点数字链接，改变原有沟通方式，提升组织经营效率',
            postion: 'top'
          },
          {
            bgImg: require('@/assets/product/digitalSystem/scene-3.png'),
            name: '大数据决策经营',
            desc: '全场景有效的数据采集、清洗和应用，以数据驱动决策，实现有效营销',
            postion: 'bottom'
          },
          {
            bgImg: require('@/assets/product/digitalSystem/scene-4.png'),
            name: '全网触达',
            desc: '依托平台通路，海量商品渠道匹配，精准满足用户需求',
            postion: 'top'
          }
        ],
        titleDescStype: {
          color: '#fff',
          opacity: 0.7
        },
        advantageList: [
          {
            icon: require("@/assets/product/svgIcon/Unicom-1.svg"),
            name: '平台化经营',
            imgShow: false,
            descList: [
              '业务流程平台全匹配覆盖，上游供应商、下游渠道数据实时共享和交互，确保信息及时与准确'
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-2.svg"),
            name: '流程自动化',
            imgShow: false,
            descList: [
              '上下游节点之间的业务流程标准化定义与配置，具备自动化流程基础，自动化流程提高业务处理的效率和服务保障'
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-3.svg"),
            name: '开放共享',
            imgShow: false,
            descList: [
              '平台开放数据共享，为平台卖家及服务商提供所需的数据和信息，实现数据互通和共享，为客户提供更优质的服务基础',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-4.svg"),
            name: ' 数据决策与服务',
            imgShow: false,
            descList: [
              '全过程的数据积淀和平台数据处理，利用大数据技术，对系统中的数据进行清理、挖掘、分析和建模。为客户服务提供有效的数据支撑和服务的精准匹配。做出更加精准和高效的决策',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-1.svg"),
            name: '丰富的平台运营策略',
            imgShow: false,
            descList: [
              '集成标准化和配置化的平台场景运营能力，满足不同企业不同经营模式的要求，及时应对市场变化',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-5.svg"),
            name: '集成在线客服',
            imgShow: false,
            descList: [
              '自主研发的平台客服沟通工具IM内置持快捷回复，常见问题，浏览足迹，店铺推荐，多客服接待等功能，提高团队协作的效率和效果',
            ]
          }
        ],
        advantageCardStyle: {
          backgroundColor: '#fff',
          height: '230px',
          padding: '30px 40px'
        },
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.page-box {
  background-color: #fff;
}
.mg-bottom-70 {
  margin-bottom: 70px;
}
.pd-top-70 {
  padding-top: 70px;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 100px;
}
.barrier-background {
  width: 100%;
  min-width: 1200px;
  height: 740px;
  background-repeat: no-repeat;
  background-size: 1920px 100%;
  background-position: center;
}
/* 从场景出发，构建完整交易生态网络 */
.flex-item {
  width: 300px;
  height: 450px;
  padding: 40px 40px 40px 20px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.flex-item-title {
  font-weight: bold;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 28px;
  margin-bottom: 15px;
}
/* 上游供应链高效聚合 */
.goods-manage-ilne {
  display: flex;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.item-ilne-icon {
  width: 22px;
  height: 16px;
  margin-right: 10px;
}
.item-ilne-title {
  display: inline-block;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.item-ilne-content {
  width: 450px;
}
.goods-manage-mid-img {
  width: 620px;
  height:540px;
}
.goods-manage-item {
  box-sizing: border-box;
  height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 53px 0;
}
.justify-center-start {
  justify-content: flex-start;
}
.width-230 {
  width: 230px;
}
.module-img-2 {
  width: 560px;
  height: 400px;
}
.flex-center {
  justify-content: center;
  padding: 0;
  padding-bottom: 74px;
}
.mg-bottom-40 {
  margin-bottom: 40px;
}
.mg-top-40 {
  margin-top: 40px;
}
.mg-bottom-110 {
  margin-bottom: 110px;
}
.mg-bottom-50 {
  margin-bottom: 50px;
}
</style>
